/**
 * GLINT-DIAPOS-ACCESSIBLES — une diapositive annoncee absente ne piege plus
 * le clavier.
 *
 * LE DEFAUT (mesure le 31/08 par Lighthouse 13, audit
 * `agent-accessibility-tree` : « ARIA hidden element must not be focusable or
 * contain focusable elements »).
 *
 * `slideshow.js` marque `aria-hidden="true"` toute diapositive visible a
 * moins de 70 % (SLIDE_VISIBLITY_THRESHOLD = 0.7). Mais leurs liens, leurs
 * boutons et le bouton PLAY VIDEO restent dans l'ordre de tabulation. On
 * tabule donc DANS un contenu declare absent : le lecteur d'ecran annonce
 * qu'il n'y a rien, le clavier y entre quand meme. C'est la contradiction
 * exacte que l'audit signale, et c'est un vrai defaut d'usage.
 *
 * ⚠️ POURQUOI PAS `inert`, QUI SERAIT LA REPONSE EVIDENTE.
 * `inert` retire du clavier ET du POINTEUR. Le seuil etant a 0,7, une carte
 * visible a 60 % porte deja `aria-hidden="true"` : la rendre inerte la
 * rendrait NON CLIQUABLE ALORS QU'ELLE EST A L'ECRAN — sur le carrousel de
 * l'accueil comme sur la galerie produit, ou une vignette voisine depasse
 * toujours. On casserait un clic pour gagner un point d'audit.
 *
 * CE QU'ON FAIT A LA PLACE : on ne retire QUE la tabulation
 * (`tabindex="-1"`), qui n'empeche ni la souris ni le doigt. La carte a
 * moitie visible reste cliquable ; elle n'est simplement plus atteignable
 * au clavier, ce qui est de toute facon ce que `aria-hidden` promettait.
 *
 * La valeur d'origine de chaque `tabindex` est conservee dans
 * `data-glint-tabindex` et rendue telle quelle au retour de la diapositive —
 * y compris l'absence d'attribut, qui n'est pas la meme chose que zero.
 */
(function () {
  'use strict';

  var FOCUSABLES =
    'a[href], area[href], button, input, select, textarea, iframe, object, ' +
    'embed, summary, model-viewer, [tabindex], [contenteditable="true"]';

  // On memorise l'etat d'origine sur l'element lui-meme : au retour de la
  // diapositive il faut rendre EXACTEMENT ce qu'on a pris.
  var MARQUE = 'data-glint-tabindex';

  function neutraliser(diapo) {
    var cibles = diapo.querySelectorAll(FOCUSABLES);
    for (var i = 0; i < cibles.length; i++) {
      var el = cibles[i];
      if (el.hasAttribute(MARQUE)) continue; // deja neutralise
      var origine = el.getAttribute('tabindex');
      // La chaine vide encode « il n'y avait pas d'attribut ».
      el.setAttribute(MARQUE, origine === null ? '' : origine);
      el.setAttribute('tabindex', '-1');
    }
  }

  function rendre(diapo) {
    var cibles = diapo.querySelectorAll('[' + MARQUE + ']');
    for (var i = 0; i < cibles.length; i++) {
      var el = cibles[i];
      var origine = el.getAttribute(MARQUE);
      if (origine === '') el.removeAttribute('tabindex');
      else el.setAttribute('tabindex', origine);
      el.removeAttribute(MARQUE);
    }
  }

  function appliquer(diapo) {
    if (!diapo || diapo.nodeType !== 1 || !diapo.matches) return;
    if (!diapo.matches('slideshow-slide')) return;
    if (diapo.getAttribute('aria-hidden') === 'true') neutraliser(diapo);
    else rendre(diapo);
  }

  function balayer(racine) {
    if (!racine || racine.nodeType !== 1) return;
    appliquer(racine);
    var trouves = racine.querySelectorAll ? racine.querySelectorAll('slideshow-slide') : [];
    for (var i = 0; i < trouves.length; i++) appliquer(trouves[i]);
  }

  function init() {
    balayer(document.body);

    // Les diapositives arrivees apres coup (recommandations produit, galerie
    // de zoom, sections rendues par l'API) et chaque bascule d'aria-hidden.
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'attributes') {
          appliquer(m.target);
        } else {
          for (var j = 0; j < m.addedNodes.length; j++) balayer(m.addedNodes[j]);
        }
      }
    }).observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-hidden'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
